import { render, staticRenderFns } from "./Warboard.vue?vue&type=template&id=ec95f018&"
import script from "./Warboard.vue?vue&type=script&lang=js&"
export * from "./Warboard.vue?vue&type=script&lang=js&"
import style0 from "./Warboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports